import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-buy-ticket-button',
  templateUrl: './buy-ticket-button.component.html',
  styleUrls: ['./buy-ticket-button.component.scss'],
})
export class BuyTicketButtonComponent implements OnInit {
  @Input() buttonText: string;

  constructor() { }

  ngOnInit() {}

}
